import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  root: {},
}));
